// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"54":"f7b81541","88":"c1ee9357","120":"c7b3c1b4","164":"ab0c83bc","407":"499a6b11","454":"9073c103","739":"34d15f5a","824":"469e1caa","887":"5ae66c8e","925":"530d1796"}[chunkId] + ".chunk.css";
};